import toast from 'toasted-notes';

export function showMessage(message: string) {
  toast.notify(message, { position: 'bottom', duration: 3000 });
}
